import OperacaoService from '@/services/OperacaoService';

export default {
    methods: {
        async verificarDeslocamentoGleba(dadosDiagnostico) {
            const glebasTerritorio = [];
            dadosDiagnostico.territorios.forEach(t => {
                const geometriasGlebas = t.glebas.map(g => g.geometria);
                glebasTerritorio.push({
                    idTerritorio: t.idTerritorio,
                    glebas: geometriasGlebas
                });
            });

            const { data } = await OperacaoService.verificarDeslocamentoGleba(glebasTerritorio);
            return Boolean(data);
        }
    }
};
